import { gql } from '../../../../types/__codegen__/ahm-api';

export const RECOMMENDED_PRODUCTS = gql(`
  query fetchRecommendedProducts($input: RecommendProductsInput) {
    recommendProducts(input: $input) {
      extras
      hospital
    }
  }
`);
